import React from "react"
import classnames from "classnames"
import styles from "./Input.less"
import { AlertIcon } from "AtomicComponents"
class Input extends React.PureComponent {
  constructor(props){
    super(props)
    // for testing purposes
    if (process && process.env && process.env.NODE_ENV === 'test'){
      this.random = 1
    }else {
      this.random = Math.random()
    }
  }
  componentDidMount(){
    const { defaultValue, onChange = () => { }  } = this.props
    if (defaultValue){
      this._onChange(defaultValue, true)
    }
  }

  _onBlurHandler = () => {
    const { onBlur = () => {}, onChange = () => {}, callOnChangeAfterBlur = true } = this.props
    setTimeout(()=>{
      onBlur()
    }, 200)
    if (callOnChangeAfterBlur) onChange(this.input.value)
  }

  _onFocusHandler = () => {
    const { onFocus = () => {}, onChange = () => {} } = this.props
    onFocus()
  }

  _onChangeHandler = (event) => {
    this._onChange(event.target.value)
  }

  _onChange = (value, forceChange = false) => {
    const { onChange = () => {} } = this.props
    this._dirtyClass(value)
    onChange(value, forceChange)
    if (forceChange && this.input) {
      this.input.value = value
    }
  }

  // Change the value without calling OnChange function
  _onChangeOnlyValue = (value) => {
    this._dirtyClass(value)
    this.input.value = value
  }

  _dirtyClass = (value) => {
    if (this.label){
      if (value && value != "") {
        this.label.classList.add(styles.PlaceholderWithValue)
      } else {
        this.label.classList.remove(styles.PlaceholderWithValue)
      }
    }
  }

  _getThisInput = () => {
    const { getThisInput = () => { } } = this.props
    getThisInput(this)
  }


  _onKeyDownHandler = (event) => {
    const {
      onClickDownKey = () => {},
      onClickUpKey = () => {},
      onClickEnterKey = () => {},
      disableEnter = false
    } = this.props

    if (event.keyCode === 40) {
      event.preventDefault()
      onClickDownKey()
    }
    if (event.keyCode === 38) {
      event.preventDefault()
      onClickUpKey()
    }

    // We don't want default behaviour of Enter on InputSearchable
    if (event.keyCode === 13 && disableEnter) {
      event.preventDefault()
      onClickEnterKey()
    }
  }

  render() {
    const {
      defaultValue,
      name = "",
      type = "text",
      label = "",
      styleName = "light",
      required = false,
      focused = false,
      message = "",
      autoComplete = "off",
      isValid = true
    } = this.props
    return (
      <div
      getthisinput = {this._getThisInput()}
      data-test="input-text"
      className={classnames({
        [styles.Input]: true
      })}>
        <input
          ref = { c => this.input = c}
          className={classnames({
            [styles.InputInput]: true,
            [styles.Focused]: focused,
            [styles.InputInvalid]: !isValid,
            [styles.InputDark]: styleName === "dark",
            [styles.InputLight]: styleName === "light"
          })}
          name={`${name}`}
          id={`${name}-${this.random}`}
          type={type}
          autoComplete={autoComplete}
          defaultValue={defaultValue}
          data-lpignore={true}
          onBlur={this._onBlurHandler}
          onFocus={this._onFocusHandler}
          onChange={this._onChangeHandler}
          onKeyDown={this._onKeyDownHandler}
        />
        <label
          ref={c => this.label = c}
          htmlFor={`${name}-${this.random}`}
          className={classnames({
            [styles.Placeholder]: true,
            [styles.PlaceholderWithValue]: false
          })}>
          {label}
          {required &&
            <span className={classnames({
              [styles.requiredStar]: true
            })}>*</span>
          }
        </label>
        <div className={classnames({
          [styles.icon]: true,
          [styles.iconShow]: !isValid
        })}>
          <AlertIcon style={{height:"1em", width: "1em"}} />
        </div>
        <div className={classnames({
          [styles.message]: true,
          [styles.messageShow]: !isValid
        })}>
          {message}
        </div>
      </div>
    )
  }
}


export default Input



// WEBPACK FOOTER //
// ./src/AtomicComponents/Input/Input.jsx